import { categories, categoryImages } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="bg-background-100 py-20 md:py-28">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="mb-12 md:mb-16">
          <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 leading-tight">
            Categorie Prodotto
          </h2>
          <p className="text-sm text-foreground-500 mt-3 max-w-md">
            Esplora tutte le categorie disponibili nello spreadsheet itaobuy. Ogni categoria ti porta direttamente ai migliori prodotti.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6" data-product-shop>
          {categories.map((cat, index) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="aspect-[4/3] w-full overflow-hidden bg-background-200/50">
                <img
                  src={categoryImages[index]}
                  alt={`${cat.name} - itaobuy spreadsheet categoria`}
                  title={`${cat.name} su Itaobuy Spreadsheet Italia`}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Info */}
              <div className="p-4 md:p-5">
                <div className="flex items-center gap-2 mb-2">
                  <i className={`${cat.icon} text-primary-500 text-lg w-5 h-5 flex items-center justify-center`}></i>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900">
                    {cat.name}
                  </h3>
                </div>
                <p className="text-xs text-foreground-500 mb-3">{cat.count}</p>
                <span className="inline-flex items-center justify-center w-full py-2 rounded-full border border-foreground-200/60 text-xs font-medium text-foreground-600 group-hover:bg-foreground-950 group-hover:text-background-50 group-hover:border-foreground-950 transition-all duration-200 whitespace-nowrap">
                  Esplora <i className="ri-arrow-right-up-line ml-1.5 text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}